import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useSession } from "@descope/react-sdk";
import { sessionSubject } from "./utils/sessionSubject.js";
/**
 * Provides a query cache that belongs to the signed-in user (openspec `session-scoped-query-cache`).
 * When a signed-in user leaves — logout, expiry, or another user's session replacing theirs — the
 * subtree remounts with a fresh client, so nothing cached for them renders again.
 */
export function SessionQueryClientProvider({ createClient, children }) {
    const { sessionToken } = useSession();
    const subject = sessionSubject(sessionToken);
    const [scope, setScope] = useState({ subject, generation: 0 });
    // Keyed on the token's subject, not the token, which rotates on every refresh. A first sign-in
    // keeps the generation: sign-in flows complete on the page that rendered them, and a remount would
    // restart them. Adjusted while rendering, so the old subtree never commits under the new session.
    if (scope.subject !== subject) {
        setScope({ subject, generation: scope.subject === undefined ? scope.generation : scope.generation + 1 });
    }
    return (_jsx(UserQueryClientProvider, { createClient: createClient, children: children }, scope.generation));
}
function UserQueryClientProvider({ createClient, children }) {
    const [client] = useState(createClient ?? (() => new QueryClient()));
    return _jsx(QueryClientProvider, { client: client, children: children });
}
//# sourceMappingURL=SessionQueryClientProvider.js.map